import Input from './input'

type InputTextProps = {
    label?: string
    hideLabel?: boolean
    required: boolean
    disabled?: boolean
    error?: { key: string; values: object } | string
    value: string
    onChange: (value: string) => void
    type?: HTMLInputElement['type']
    placeholder?: string
    className?: string
    wrapperClassName?: string
    maxLength?: number
    dataCy?: string
}

const InputText = ({
    label,
    hideLabel,
    required,
    error,
    value,
    disabled,
    onChange,
    placeholder,
    type = 'text',
    className,
    wrapperClassName,
    maxLength,
    dataCy,
}: InputTextProps) => {
    return (
        <Input label={label} error={error} required={required} hideLabel={hideLabel} className={wrapperClassName}>
            <input
                value={value}
                placeholder={placeholder ?? label}
                type={type}
                className={`number-input ${disabled ? 'bg-gray-200!' : ''} ${className}`}
                maxLength={maxLength}
                data-cy={dataCy}
                onChange={(event) => {
                    if (!event.target.value) {
                        onChange(null as any)
                    } else if (value?.toString() != event.target.value) {
                        onChange(event.target.value as any)
                    }
                }}
                disabled={disabled}
            />
        </Input>
    )
}

export default InputText
